import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import {
  IonButton,
  IonContent,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonText,
} from '@ionic/angular/standalone';
import { PosStoreService } from '@adminpages/pos-state';

@Component({
  selector: 'foco-pos-login-page',
  standalone: true,
  imports: [
    FormsModule,
    IonButton,
    IonContent,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonText,
  ],
  template: `
    <ion-content class="pos-page login-content">
      <main class="login-shell">
        <section class="login-brand">
          <span class="brand-mark">
            <ion-icon name="storefront-outline"></ion-icon>
          </span>
          <p>Foco Admin</p>
          <h1>Operaciones</h1>
          <span>Ventas, caja y seguimiento de taller conectados al panel administrativo.</span>
        </section>

        <section class="login-card">
          <div>
            <h2>Entrar a operaciones</h2>
            <ion-text color="medium">Usa tu usuario del panel para acceder a los módulos habilitados.</ion-text>
          </div>

          <ion-list lines="none">
            <ion-item>
              <ion-label position="stacked">Email</ion-label>
              <ion-input [(ngModel)]="email" type="email" placeholder="jvega@fococreativo.mx"></ion-input>
            </ion-item>
            <ion-item>
              <ion-label position="stacked">Password</ion-label>
              <ion-input [(ngModel)]="password" type="password" placeholder="********"></ion-input>
            </ion-item>
            <ion-item>
              <ion-label position="stacked">Dispositivo</ion-label>
              <ion-input [(ngModel)]="deviceName" placeholder="POS iPad mostrador"></ion-input>
            </ion-item>
          </ion-list>

          @if (store.errorMessage(); as error) {
            <ion-text color="danger">{{ error }}</ion-text>
          }

          <ion-button expand="block" size="large" [disabled]="store.authLoading()" (click)="continue()">
            {{ store.authLoading() ? 'Entrando...' : 'Continuar' }}
          </ion-button>
        </section>
      </main>
    </ion-content>
  `,
  styles: `
    .login-content {
      --padding-bottom: calc(24px + var(--ion-safe-area-bottom, 0px));
      --padding-end: calc(24px + var(--ion-safe-area-right, 0px));
      --padding-start: calc(24px + var(--ion-safe-area-left, 0px));
      --padding-top: calc(24px + var(--ion-safe-area-top, 0px));
    }

    .login-shell {
      align-items: center;
      display: grid;
      gap: 28px;
      grid-template-columns: minmax(0, 1fr) 420px;
      margin: 0 auto;
      max-width: 1080px;
      min-height: calc(100vh - 48px);
      min-height: calc(
        100dvh - 48px - var(--ion-safe-area-top, 0px) - var(--ion-safe-area-bottom, 0px)
      );
    }

    .login-brand {
      display: grid;
      gap: 14px;
      max-width: 560px;
    }

    .brand-mark {
      align-items: center;
      background: var(--pos-color-primary);
      border-radius: 22px;
      color: white;
      display: inline-flex;
      font-size: 34px;
      height: 68px;
      justify-content: center;
      width: 68px;
    }

    .login-brand p {
      color: var(--pos-color-primary);
      font-weight: 800;
      margin: 0;
      text-transform: uppercase;
    }

    .login-brand h1 {
      color: var(--pos-color-text);
      font-size: 72px;
      line-height: 0.9;
      margin: 0;
      overflow-wrap: anywhere;
    }

    .login-brand span {
      color: var(--pos-color-muted);
      font-size: 18px;
      max-width: 520px;
    }

    .login-card {
      background: var(--pos-color-surface);
      border: 1px solid var(--pos-color-border);
      border-radius: 8px;
      box-shadow: 0 16px 40px var(--pos-color-shadow);
      display: grid;
      gap: 20px;
      padding: 24px;
    }

    .login-card h2 {
      margin: 0 0 6px;
    }

    ion-item {
      --background: var(--pos-color-input);
      --color: var(--pos-color-text);
      --border-radius: 8px;
      margin-bottom: 10px;
    }

    @media (max-width: 820px) {
      .login-shell {
        align-content: center;
        grid-template-columns: 1fr;
      }

      .login-brand h1 {
        font-size: 42px;
      }
    }
  `,
})
export class LoginPageComponent {
  private readonly router = inject(Router);
  readonly store = inject(PosStoreService);

  email = 'jvega@fococreativo.mx';
  password = '';
  deviceName = 'POS cURL';

  async continue(): Promise<void> {
    try {
      await this.store.login(this.email, this.password, this.deviceName);
      void this.router.navigate(['/workspace']);
    } catch {
      // El store expone el error para la UI.
    }
  }
}
